"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var form_1 = __importDefault(require("~/components/users/estimates/requests/messages/form"));
var reserve_date_modal_1 = __importDefault(require("~/components/users/estimates/requests/messages/reserve_date_modal"));
var reservation_date_store_1 = __importDefault(require("~/stores/users/estimates/requests/reservation_date_store"));
var user_profile_store_1 = __importDefault(require("~/stores/users/estimates/requests/user_profile_store"));
var EditArea = /** @class */ (function (_super) {
    __extends(EditArea, _super);
    function EditArea(props) {
        var _this = _super.call(this, props) || this;
        _this.isModalOpen = false;
        _this.handleClickCalendarButton = function () {
            _this.isModalOpen = true;
        };
        _this.handleModalClose = function () {
            _this.isModalOpen = false;
        };
        _this.handleClickSubmitButton = function () {
            _this.reservationDateStore.postData().then(function () {
                _this.isModalOpen = false;
            });
        };
        _this.reservationDateStore = new reservation_date_store_1.default(props.reservationDateStoreProps);
        _this.userProfileStore = new user_profile_store_1.default(props.userProfileStoreProps);
        return _this;
    }
    EditArea.prototype.render = function () {
        var formProps = this.props.formProps;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(form_1.default, __assign({}, formProps, { onClickCalendarButton: this.handleClickCalendarButton, userProfileStore: this.userProfileStore })),
            react_1.default.createElement(reserve_date_modal_1.default, { isModalOpen: this.isModalOpen, onClose: this.handleModalClose, reservationDates: this.reservationDateStore.reservationDates, onClickSubmitButton: this.handleClickSubmitButton, onClickConfirmDateButton: this.reservationDateStore.setDate })));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof reservation_date_store_1.default !== "undefined" && reservation_date_store_1.default) === "function" ? _a : Object)
    ], EditArea.prototype, "reservationDateStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof user_profile_store_1.default !== "undefined" && user_profile_store_1.default) === "function" ? _b : Object)
    ], EditArea.prototype, "userProfileStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], EditArea.prototype, "isModalOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditArea.prototype, "handleClickCalendarButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditArea.prototype, "handleModalClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditArea.prototype, "handleClickSubmitButton", void 0);
    EditArea = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], EditArea);
    return EditArea;
}(react_1.default.PureComponent));
exports.default = EditArea;
